import s from './SkipButton.scss';
export const SkipButton = ({ text, dataHook, className }) => `
  <button 
    ${dataHook ? `data-hook=${dataHook}` : ''}
    tabindex="-1"
    class='${s.button} ${className || ''}'
   >
    ${text}
   </button>
`;
//# sourceMappingURL=SkipButton.js.map